import {
  GET_GIMS_SECTIONS_SEARCH,
  GET_GIMS_SECTION,
  SAVE_GIMS_SECTION_NO_ERROR,
  SAVE_GIMS_SECTION_ERROR,
  CLEAR_GIMS_SECTION,
  SET_SEARCH_PARAMS_GIMS_SECTIONS,
} from "../../types";

const initialState = {
  searchParams: {},
  sections: [],
  section: {},
  message: "",
  isSaved: false,
};

export const gimsSectionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GIMS_SECTIONS_SEARCH: {
      return {
        ...state,
        sections: action.data,
      };
    }
    case SET_SEARCH_PARAMS_GIMS_SECTIONS:
      return {
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      };
    case GET_GIMS_SECTION:
      return (() => ({
        ...state,
        section: action.data,
      }))();
    case SAVE_GIMS_SECTION_ERROR:
      return (() => ({
        ...state,
        message: action.data,
        isSaved: false,
      }))();
    case SAVE_GIMS_SECTION_NO_ERROR:
      return (() => ({
        ...state,
        message: action.data,
        isSaved: true,
      }))();
    case CLEAR_GIMS_SECTION:
      return (() => ({
        ...state,
        section: {},
        isSaved: false,
        message: "",
      }))();
    default:
      return state;
  }
};
